<template lang="pug">
.watchlist-wrap
  .watchlist(v-if="watchlist", :class="{ shown: watchlistShown }")
    global-events(v-if="watchlistShown && !chartShown", @keyup.16="launchNonGenRoboReport")
    .items
      .item(v-for="({ pub: { thumbnail, name } }, key) in watchlist",
            :key="key",
            :key1="key",
            :title="`open ${ name }`",
            @click.prevent.stop.capture="({ shiftKey }) => shiftKey && '' || loadRobo(key, shiftKey, name)",
            @mouseenter.once="preLoadRobo(key)",
            @mousemove="hoverPub !== key && (hoverPub = key)",
            @mouseleave="hoverPub = null",
            :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
            .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
      //-.item(v-for="({ pub: { thumbnail } }, key) in watchlist",
      //-      :key="key",
      //-      @click="loadRobo(key)",
      //-      @mouseenter.once="preLoadRobo(key)",
      //-      @mousemove="hoverPub !== key && (hoverPub = key)",
      //-      @mouseleave="hoverPub = null",
      //-      :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
      //-      .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
      //-.item(v-for="({ pub: { thumbnail } }, key) in watchlist",
      //-      :key="key",
      //-      @click="loadRobo(key)",
      //-      @mouseenter.once="preLoadRobo(key)",
      //-      @mousemove="hoverPub !== key && (hoverPub = key)",
      //-      @mouseleave="hoverPub = null",
      //-      :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
      //-      .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
      //-.item(v-for="({ pub: { thumbnail } }, key) in watchlist",
      //-      :key="key",
      //-      @click="loadRobo(key)",
      //-      @mouseenter.once="preLoadRobo(key)",
      //-      @mousemove="hoverPub !== key && (hoverPub = key)",
      //-      @mouseleave="hoverPub = null",
      //-      :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
      //-      .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
      //-.item(v-for="({ pub: { thumbnail } }, key) in watchlist",
      //-      :key="key",
      //-      @click="loadRobo(key)",
      //-      @mouseenter.once="preLoadRobo(key)",
      //-      @mousemove="hoverPub !== key && (hoverPub = key)",
      //-      @mouseleave="hoverPub = null",
      //-      :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
      //-      .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
      //-.item(v-for="({ pub: { thumbnail } }, key) in watchlist",
      //-      :key="key",
      //-      @click="loadRobo(key)",
      //-      @mouseenter.once="preLoadRobo(key)",
      //-      @mousemove="hoverPub !== key && (hoverPub = key)",
      //-      @mouseleave="hoverPub = null",
      //-      :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
      //-      .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
      //-.item(v-for="({ pub: { thumbnail } }, key) in watchlist",
      //-      :key="key",
      //-      @click="loadRobo(key)",
      //-      @mouseenter.once="preLoadRobo(key)",
      //-      @mousemove="hoverPub !== key && (hoverPub = key)",
      //-      @mouseleave="hoverPub = null",
      //-      :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
      //-      .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
      //-.item(v-for="({ pub: { thumbnail } }, key) in watchlist",
      //-      :key="key",
      //-      @click="loadRobo(key)",
      //-      @mouseenter.once="preLoadRobo(key)",
      //-      @mousemove="hoverPub !== key && (hoverPub = key)",
      //-      @mouseleave="hoverPub = null",
      //-      :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
      //-      .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
      //-.item(v-for="({ pub: { thumbnail } }, key) in watchlist",
      //-      :key="key",
      //-      @click="loadRobo(key)",
      //-      @mouseenter.once="preLoadRobo(key)",
      //-      @mousemove="hoverPub !== key && (hoverPub = key)",
      //-      @mouseleave="hoverPub = null",
      //-      :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
      //-      .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
      //-.item(v-for="({ pub: { thumbnail } }, key) in watchlist",
      //-      :key="key",
      //-      @click="loadRobo(key)",
      //-      @mouseenter.once="preLoadRobo(key)",
      //-      @mousemove="hoverPub !== key && (hoverPub = key)",
      //-      @mouseleave="hoverPub = null",
      //-      :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
      //-      .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
      //-.item(v-for="({ pub: { thumbnail } }, key) in watchlist",
      //-      :key="key",
      //-      @click="loadRobo(key)",
      //-      @mouseenter.once="preLoadRobo(key)",
      //-      @mousemove="hoverPub !== key && (hoverPub = key)",
      //-      @mouseleave="hoverPub = null",
      //-      :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
      //-      .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
      //-.item(v-for="({ pub: { thumbnail } }, key) in watchlist",
      //-      :key="key",
      //-      @click="loadRobo(key)",
      //-      @mouseenter.once="preLoadRobo(key)",
      //-      @mousemove="hoverPub !== key && (hoverPub = key)",
      //-      @mouseleave="hoverPub = null",
      //-      :class="{ full: key === hoverPub, before: key === hoverPubs.before, after: key === hoverPubs.after }")
      //-      .bg(:style="{ 'background-image': `url('${ thumbnail }')` }")
    //.opener(@click="roboWeaveShown = true") &raquo;
    //-.close(@click="toggleSkimmer")
    notifications
</template>
<script>
let shiftTimer;
let recentShift;
import { mapGetters } from 'vuex';
import { vuexComputed } from '@/helpers';
import notifications from './notifications';
export default {
  name: 'watchlist',
  data() {
    return {
      hoverPub: null
    };
  },
  computed: {
    //...mapGetters(['customThemes', 'selectedThemes', 'documentsSort', 'skimmerSort', 'themes', 'robo', 'folderLiteCache', 'analytics', 'chartShown', 'hoverTheme']),
    ...mapGetters(['watchlist', 'watchlistHideESG', 'publishers']),
    ...vuexComputed(
      'chartShown',
      'roboReportShown',
      'watchlistThemesShown',
      'watchlistShown',
      'watchlistThemesRefPub',
      'refPubInfoShown',
      'watchlistThemesParentFilter',
      'selectedWatchlistThemes',
      'roboReportLaunchedFromWatchList'
    ),
    hoverPubs() {
      const { hoverPub, watchlist } = this;
      const r = {};
      if (hoverPub) {
        const pubs = Object.keys(watchlist);
        const index = pubs.indexOf(hoverPub);
        const before = pubs[index - 1];
        if (before) {
          r.before = before;
        }
        const after = pubs[index + 1];
        if (after) {
          r.after = after;
        }
      }
      return r;
    },
    items() {
      const { selectedThemes, customThemes, folderList, skimmerSort } = this;
      const selectedThemesKeys = Object.keys(selectedThemes || {});
      const { length } = selectedThemesKeys;
      return filter();
      function filter() {
        // console.log('items filter 2', (Object.entries(folderList) || []).filter(([did, { th, tg }]) => !length || hasThemes(selectedThemes, th, customThemes, tg))
        //     .reduce((all, [did, doc]) => {
        //       all[did] = doc;
        //       return all;
        //     }, {}));
        //return (Object.entries(folderList) || []).filter(([did, { th, tg }]) => !length || hasThemes(selectedThemes, th, customThemes, tg))
        const sorters = (length && {
          Weight: (a, b) => totalWeights(b[1], 'w') - totalWeights(a[1], 'w'),
          vis: (a, b) => totalWeights(b[1], 'v') - totalWeights(a[1], 'v'),
          age: (a, b) => b[1].ds?.dpa - a[1].ds?.dpa,
          pos: (a, b) => totalWeights(b[1], 'p') - totalWeights(a[1], 'p'),
          neg: (a, b) => totalWeights(b[1], 'n') - totalWeights(a[1], 'n')
        }) || {
          Weight: (a, b) => b[1].w - a[1].w,
          vis: (a, b) => b[1].v - a[1].v,
          age: (a, b) => b[1].ds?.dpa - a[1].ds?.dpa,
          pos: (a, b) => b[1].p - a[1].p,
          neg: (a, b) => b[1].n - a[1].n
        };
        return (Object.entries(folderList) || [])
          .filter(([did, { th, tg }]) => {
            //console.log('did', did, hasThemes(selectedThemes, th, customThemes, tg));
            return !length || hasThemes(selectedThemes, th, customThemes, tg);
          })
          .sort(sorters[skimmerSort])
          .reduce((all, [did, doc]) => {
            all[did] = doc;
            return all;
          }, {});
      }
      function totalWeights(item, prop) {
        return selectedThemesKeys.reduce((total, theme) => total + item.themes[theme]?.[prop] || 0, 0);
      }
      function hasThemes(selectedThemes, th, customThemes, tg) {
        //Object.keys(selectedThemes);
        const cts = Object.keys(selectedThemes || {}).filter(k => k / 1).map(k => customThemes[k]);
        //console.log(4232, cts, th?.join(', '), th?.some(t => selectedThemes[(t || '').replace(/\s/, '-')]));
        //console.log(4232, cts, Object.keys(selectedThemes || {}).join(', '), '\n\n', th?.join(', '), th?.some(t => selectedThemes[t]));
        return th?.some(n => selectedThemes[n]) || cts?.some(ct => hasKeywords(ct, tg));
        function hasKeywords({ selectedTags, andOr }, tg) {
          let r = true;
          const keys = Object.keys(selectedTags || {});
          //console.log('hasKeywords', keys, tg?.join(', '));
          //todo: aliases
          if (andOr === 'and') {
            keys.forEach(tag => {
              r = r && tg?.includes(tag);
            });
          } else if (andOr === 'or') {
            if (keys.length) {
              r = tg?.some(n => selectedTags[n]);
            }
          } else {
            keys.forEach(tag => {
              r = r && !tg?.includes(tag);
            });
          }
          return r;
        }
        //return Object.keys(selectedThemes).some(({ n }) => th?.includes(n));
        //return th?.filter(t => selectedThemes[t]).length === Object.keys(selectedThemes).length;
      }
    }
  },
  methods: {
    async openReport() {
      this.roboReportLaunchedFromWatchList = !this.chartShown;
      await (this.selectedWatchlistThemes = {});
      await (this.watchlistThemesParentFilter = '');
      this.chartShown = this.roboReportShown = this.watchlistThemesShown = true;
    },
    async openESGReport() {
      this.roboReportLaunchedFromWatchList = !this.chartShown;
      await (this.selectedWatchlistThemes = {});
      await (this.watchlistThemesParentFilter = 'ESG themes');
      this.chartShown = this.roboReportShown = this.watchlistThemesShown = this.roboReportLaunchedFromWatchList = true;
    },
    async openCustomReport(theme) {
      await (this.selectedWatchlistThemes = {});
      await (this.watchlistThemesParentFilter = theme);
      this.chartShown = this.roboReportShown = this.watchlistThemesShown = this.roboReportLaunchedFromWatchList = true;
    },
    launchNonGenRoboReport({ keyCode }) {
      clearTimeout(shiftTimer);
      shiftTimer = setTimeout(() => (recentShift = false), 400);
      if (recentShift) {
        //console.log('recentShift');
        this.chartShown = this.roboReportShown = this.watchlistThemesShown = true;
        recentShift = false;
      } else {
        recentShift = true;
      }

    },
    //...mapActions(['loadDoco', 'loadInsights', 'loadFolder']),
    async loadRobo(key, shift, name) {
      console.log('shift', !!shift);
      const { $store: { dispatch } } = this;
      if (shift) {
        this.watchlistShown = false;
        dispatch('loadRobo', key);
      } else {
        await this.openReportCard(name);
      }
    },
    async openReportCard(name) {
      const { watchlistHideESG, openReport, openESGReport, publishers } = this;
      await (watchlistHideESG && openReport || openESGReport)();
      const [pubKey] = Object.entries(publishers).find(([_, { n }]) => n === name);
      console.log(name, pubKey);
      if (pubKey) {
        await (this.watchlistThemesRefPub = pubKey);
      }
      this.refPubInfoShown = true;
    },
    preLoadRobo(key) {
      // todo: implement
    },
    filteredDocs(topDocs) {
      return topDocs.slice(0, 14);
    },
    filteredThemes(topThemes) {
      return topThemes.slice(0, 18);
      const { themesFilter, themes} = this;
      //console.log('thms2', Object.values(themes).map(({ t, c }) => `${ t }: ${ c }`).join(', '));
      const filters = themesFilter?.split(/\s+/).map(item => new RegExp(item.toLowerCase().replace(/\W/g, '.'), 'i'));
      return Object.values(themes).filter(({ k }) => filters.every(filter => filter.test(k.join('|')))).sort((a, b) => b.c - a.c);
    },
    async click(key, id) {
      console.log('key/id', key, id);
      await this.loadInsights({ id });
      await(this.folderDoco = id);
      await(this.insightsDoco = id);
      await(this.roboFolder = key);
      await (this.backToRobo = true);
      //await (this.loadInsights(id));
      await (this.loadDoco(id));
      await (this.loadFolder(key));
      this.roboWeaveShown = this.notificationsShown = false;
      window.history.pushState({ fromRobo: true }, 'Weave - folder view');
      console.log('state added from robo folder view');
    }
  },
  components: { notifications },
  mounted() {
    const [_, name] = (/[\?\&\;]rc\=([^\;\&]+)/.exec(location.search) || []);
    if (name) {
      console.log('rc', name);
      this.openReportCard(name);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../scss/global';
.watchlist-wrap {
  .watchlist {
    //display: ;
    /*position: fixed;
    top: 5rem;
    bottom: 1rem;
    //left: 21vw;
    left: 51vw;
    //width: 76vw;
    width: 46vw;*/
    position: absolute;
    top: 4rem;
    z-index: 1;
    width: 100vw;
    max-width: 100vw;
    min-height: 100vh;
    background-color: white;
    //box-shadow: 1px 1px 3px black;
    //border-radius: 0.25rem;
    transform: translate3d(-110vw, 0, 0);
    transform-origin: top left;
    transition: transform 700ms ease-in-out;
    will-change: transform;
    //z-index: -1;
    cursor: default;
    //transform: none;
    padding: 3rem 1rem 0;
    &.shown {
      transform: none;
    }
    & > .opener {
      cursor: pointer;
      display: none;
      position: fixed;
      top: 1rem;
      left: 110%;
      //margin-left: 3rem;
      //transform: translate3d(5.5rem, 0, 0);
      transform: translate3d(-2rem, 0, 0);
      font-size: 2rem;
      padding: 0.25rem 0.125rem;
      /*border-top-right-radius: 0.25rem;*/
      /*border-bottom-right-radius: 0.25rem;*/
      border-radius: 0.25rem;
      color: white;
      background-color: $brn;
      opacity: 0.75;
      transition: opacity 250ms ease-in-out 1500ms;
      will-change: opacity;
      &:hover {
        opacity: 1;
      }
    }
    &:not(.shown) > .opener {
      display: block;
      transition-delay: 10ms;
    }
    & > .items {
      max-width: 100vw;
      box-sizing: border-box;
      padding: 1rem;
      display: grid;
      grid-template-columns: repeat(24, 1fr);
      grid-column-gap: 0.1rem;
      //grid-column-gap: 2rem;
      grid-row-gap: 2rem;
      & > .item {
        cursor: pointer;
        box-sizing: border-box;
        padding: 0.25rem;
        border: 2px solid #f5f5f5;
        border-radius: 0.125rem;
        background-color: white;
        transition: all 200ms ease-in-out;
        will-change: all;
        transform-origin: center;
        &.full {
          border-color: orange;
          z-index: 1;
          transform: scale(1.2);
        }
        &.before {
          transform: scale(0.9) translate3d(0.4rem, 0, 0);
        }
        &.after {
          transform: scale(0.9) translate3d(-0.4rem, 0, 0);
        }
        &.on {
          border-color: orange;
        }
        & > .bg {
          padding-top: 100%;
          background: white no-repeat center;
          background-size: contain;
        }
      }
    }
    & > .sorter {
      position: absolute;
      top: 0;
      left: 0;
    }
    //&.open {
    .heading {
      font-size: 1.5rem;
      font-weight: 200;
      position: absolute;
      top: 0.25rem;
      left: 0.5rem;
      opacity: 0.4;
      transition: opacity 250ms ease-in-out;
      will-change: opacity;
    }
    .folders {
      & > .heading {
        color: $brn;
        opacity: 1;
        font-size: 2rem;
        left: 1rem;
      }
      .items {
        display: grid;
        pointer-events: all;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: auto;
        grid-row-gap: 1.25rem;
        padding-right: 20rem;
        //grid-template-columns: repeat(4, 1fr);
        //grid-template-columns: repeat(7, 1fr);
        //overflow: auto;
        //max-height: calc(100vh - 6rem);
      }
    }
    .close {
      pointer-events: all;
      display: block;
    }
    .count {
      display: none;
    }
    //}
    .count {
      position: absolute;
      top: 0;
      left: 100%;
      transform: translate3d(0.5rem, 0, 0);
    }
    .close {
      display: none;
      position: absolute;
      top: 0.25rem;
      right: 0.25rem;
      height: 3rem;
      width: 3rem;
      &:hover {
        &::after {
          color: black;
        }
      }
      &::after {
        color: #dadada;
        cursor: pointer;
        content: '\00d7';
        position: absolute;
        top: -0.3rem;
        right: -0rem;
        font-size: 1.25rem;
        //margin-top: -0.05rem;
        //transform: translate3d(0, -70%, 0);
      }
    }
  }
}
</style>
